import useBodyScrollLock from "hooks/useBodyScrollLock";

/**
 * 공통 확인 모달 (2버튼) — 후니드 modal-dimmed 패턴 재사용.
 *  <ConfirmModal
 *    isShow={open} title="지원하시겠습니까?" body="..."
 *    cancelText="취소" confirmText="지원하기"
 *    onCancel={...} onConfirm={...} />
 *  cancelText={null} 이면 확인 버튼 하나만 보인다(완료 안내용).
 *
 * ⚠️ body 는 열렸을 때만 렌더한다. 종전엔 숨김 상태에서도 항상 렌더해서,
 *    body 로 넘긴 컴포넌트가 화면 진입과 동시에 마운트되며 API 를 쏘았다.
 *    실제 사고: 공고 상세 3종(캐스팅·대타·채용)의 ResumePicker 가 페이지 로드 즉시
 *    GET /resumes 를 호출 → 강사·무용수가 아닌 회원(학원·원장 등)에게
 *    "강사·무용수 회원 유형에서만 사용할 수 있는 기능입니다" 전역 팝업이 떴다.
 *    (공고 열람 자체는 모든 유형에 열려 있는데도)
 */
const ConfirmModal = ({
  isShow,
  title,
  body,
  cancelText = "취소",
  confirmText = "확인",
  onCancel,
  onConfirm,
  busy = false,
}) => {
  useBodyScrollLock(isShow);
  return (
    <div className={`modal-dimmed ${isShow ? "is-show" : ""}`}>
      <div className="modal">
        {title && <div className="tit-box"><p>{title}</p></div>}
        {isShow && body && (
          <div className="con-box">
            {typeof body === "string"
              ? <p className="t-body">{body}</p>
              : <div className="t-body">{body}</div>}
          </div>
        )}
        <div className="btn-group">
          {cancelText && (
            <button type="button" className="btn-md outlined" onClick={onCancel} disabled={busy}>{cancelText}</button>
          )}
          <button type="button" className="btn-md filled primary" onClick={onConfirm} disabled={busy}>{confirmText}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
